import api from "@/api/apiConfig"
import { Post, Get } from './base/baseAjax'
let getNoticeListBySender = (param) => {
    //获取通知列表
    return Post({
        url: api.notice.getNoticeListBySender,
        bodyParam: param
    })
}
let saveNotice = (param) => {
    //保存草稿
    return Post({
        url: api.notice.saveNotice,
        bodyParam: param
    })
}
let sendNotice = (param) => {
    //发送通知
    return Post({
        url: api.notice.sendNotice,
        bodyParam: param
    })
}
let getDetailsById = (param) => {
    //获取通知详情
    return Get({
        url: api.notice.getDetailsById,
        PathParam: param
    })
}
let getOrganization = () => {
    //获取组织架构
    return Get({
        url: api.notice.getOrganization
    })
}

let sendNoticeAgain = (param) => {
    //重新发送通知
    return Get({
        url: api.notice.sendNoticeAgain,
        PathParam: param
    })
}

let deleteNotice = (param) => {
    //删除通知
    return Get({
        url: api.notice.deleteNotice,
        PathParam: param
    })
}

export default {
    getNoticeListBySender,
    saveNotice,
    sendNotice,
    getDetailsById,
    getOrganization,
    sendNoticeAgain,
    deleteNotice
}


// WEBPACK FOOTER //
// ./src/services/notice.js